import { isArray, isObject, isString } from "@churchofjesuschrist/maps-utils";
export default class Filter {
  static create(field, operator, operand, types = undefined) {
    return Filter.toJSON({
      field,
      operator,
      operand,
      types
    });
  }
  static toJSON(filter) {
    if (isObject(filter)) {
      return filter;
    } else if (isString(filter)) {
      let field = null,
        operator = null,
        operand = null,
        types = undefined;
      //TODO: split by operator like in java
      if (field && operator && operand) {
        return {
          field,
          operator,
          operand,
          types
        };
      }
    }
    return null;
  }
  static serialize(filter) {
    if (isString(filter)) {
      return filter;
    } else {
      let json = Filter.toJSON(filter);
      if (json) {
        //TODO: make sure operator is symbol and not word?
        let operand = isArray(json.operand) ? json.operand.join("|") : json.operand;
        let types = json.types ? "@:" + (isArray(json.types) ? json.types.join(";") : json.types) : "";
        return json.field + json.operator + operand + types;
      }
    }
    return null;
  }
}